import CustomDialog, { ContentContainer } from '../../../dialogs/CustomDialog'
import { StyleSheet, View } from 'react-native'
import NormalIcon from '../../../icons/NormalIcon'
import Colors from '../../../../constants/Colors'
import { CustomText } from '../../../text/StyledText'
import { txt } from '../../../../locales/i18n'
import { ButtonPrimary } from '../../../buttons/StyledButtons'
import React from 'react'
import CustomPressable from '../../../pressables/CustomPressable'

export function CancelWithMessageDialog({ visible, onDismiss, sendMessage }) {
	return (
		<CustomDialog visible={visible} onDismiss={onDismiss}>
			<ContentContainer>
				<CustomPressable
					style={{ alignSelf: 'flex-end', position: 'absolute', paddingLeft: 24, zIndex: 1 }}
					accessibilityRole="button"
					onPress={onDismiss}
				>
					<NormalIcon name="times" color={Colors.inactive} />
				</CustomPressable>
				<CustomText font="largeBold">{txt(`learnDanish.cancelMessageTitle`)}</CustomText>
				<CustomText style={{ paddingTop: 12 }}>{txt(`learnDanish.cancelMessageText`)}</CustomText>
			</ContentContainer>
			<View style={{ padding: 12 }}>
				<ButtonPrimary
					title={txt(`learnDanish.cancelMessageSend`)}
					style={styles.button}
					titleStyle={styles.buttonTitle}
					onPress={sendMessage}
				/>
			</View>
		</CustomDialog>
	)
}

export function CannotCancelDialog({ visible, onDismiss, sendMessage }) {
	return (
		<CustomDialog visible={visible} onDismiss={onDismiss}>
			<ContentContainer>
				<CustomPressable
					style={{ alignSelf: 'flex-end', position: 'absolute', paddingLeft: 24, zIndex: 1 }}
					accessibilityRole="button"
					onPress={onDismiss}
				>
					<NormalIcon name="times" color={Colors.inactive} />
				</CustomPressable>
				<CustomText font="largeBold">{txt(`learnDanish.cannotCancelTitle`)}</CustomText>
				<CustomText style={{ paddingTop: 12 }}>{txt(`learnDanish.cannotCancelText`)}</CustomText>
			</ContentContainer>
			<View style={{ padding: 12 }}>
				<ButtonPrimary
					title={txt(`learnDanish.cancelMessageSend`)}
					style={styles.button}
					titleStyle={styles.buttonTitle}
					onPress={sendMessage}
				/>
			</View>
		</CustomDialog>
	)
}

const styles = StyleSheet.create({
	button: {
		borderRadius: 10,
		backgroundColor: Colors.redCross.background,
		paddingVertical: 13,
		paddingHorizontal: 32,
		marginLeft: 12,
		minWidth: 115,
	},
	buttonTitle: {
		color: Colors.redCross.text,
		fontSize: 14,
	},
})
